import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getAxiosResponse,
  deleteAxiosResponse,
  putAxiosResponse,
  postAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import DataTable, { createTheme } from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Constants from "../../../Constants";
import $ from "jquery";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
export default function ProjectSettingIntendend() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const [intendedName, setIntendedName] = useState("");
  const [intendedId, setIntendedId] = useState("");
  const [pending, setPending] = useState(true);
  const [success,setSuccess] = useState(false)
  const [conintendent, setconintendent] = useState(false);
  const [intendendUse, setIntendedUse] = useState([]);
  const [errorMsg,setErrorMsg]=useState("")
  const [errors,setErrors] = useState('')
  const closeRef = useRef();
  const backRef = useRef();
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.name.toLowerCase();
    const b = rowB.name.toLowerCase();

    if (a > b) {
        return -1;
    }

    if (b > a) {
        return 1;
    }

    return 0;
};
  const columns = [
    {
      id: "intendendUse.name",
      name: translate("settings.name"),
      maxWidth: "350px",
      selector: (row) => row.name,
      sortable: true,
      sortFunction: caseInsensitiveSort,
      cell: (row) => (
        <div className="file-actions flex-center" aria-label="test">{row.name}</div>
      )
    },
    {
      id: "intendendUse.tasks",
      name: translate("settings.work_items"),
      // maxWidth:"10px",
      wrap: true,
      sortable: true,
      center: true,
      selector: (row) => row.tasks,
      cell: (row) =>
      (
        <div className="file-actions flex-center" aria-label="test">{
          row.tasks.map((task, taskIndex) => {
            if (row?.tasks?.length > taskIndex + 1) {
              return task.projectTaskType.display + ", ";
            } else {
              return task.projectTaskType.display;
            }
          })
        }</div>
      )
       
    },
    {
      id: "asset.action",
      name: "Action",
      center: true,
      selector: (row) => row.action,
      cell: (row) => (
        <div className="file-actions flex-center">
          <button className="mr-15 inline-flex" aria-label="delete" onClick={() => confirmDelete(row)} >
            <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" >
              <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z"
                fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3" />
            </svg>
          </button>
          <button className="mr-15 inline-flex" aria-label="rename" onClick={() => showModel(row)} title="Rename Intended Use">
            <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none" >
              <path d="M20.2448 8.61472C20.1504 8.61498 20.0569 8.59649 19.9696 8.56035C19.8824 8.5242 19.8032 8.4711 19.7367 8.40413L16.687 5.35519C16.5523 5.2204 16.4766 5.03762 16.4766 4.84703C16.4766 4.65645 16.5523 4.47366 16.687 4.33888L18.2122 2.81441C18.6228 2.42207 19.1688 2.20313 19.7367 2.20312C20.3045 2.20313 20.8506 2.42207 21.2611 2.81441L22.2774 3.83072C22.6817 4.23508 22.9088 4.78343 22.9088 5.35519C22.9088 5.92695 22.6817 6.4753 22.2774 6.87966L20.7523 8.40413C20.6858 8.47101 20.6067 8.52406 20.5196 8.56021C20.4325 8.59635 20.3391 8.61488 20.2448 8.61472ZM18.2115 4.84703L20.2448 6.87966L21.2626 5.86335C21.3973 5.72856 21.473 5.54578 21.473 5.35519C21.473 5.1646 21.3973 4.98182 21.2626 4.84703L20.2448 3.83072C20.108 3.69989 19.926 3.62687 19.7367 3.62687C19.5473 3.62687 19.3653 3.69989 19.2285 3.83072L18.2115 4.84703Z"
                fill="#1D4ED8" />
              <path d="M10.5537 15.9707C10.3355 15.9699 10.1204 15.9195 9.92462 15.8233C9.72882 15.7271 9.55749 15.5876 9.42361 15.4153C9.28972 15.2431 9.19681 15.0426 9.15189 14.8291C9.10697 14.6157 9.11124 14.3947 9.16436 14.1831L9.79327 11.6675C9.88858 11.2889 10.0842 10.943 10.3596 10.6663L16.6846 4.3413C16.8194 4.20655 17.0022 4.13086 17.1928 4.13086C17.3834 4.13086 17.5662 4.20655 17.701 4.3413L20.7506 7.39024C20.8854 7.52502 20.9611 7.70781 20.9611 7.89839C20.9611 8.08898 20.8854 8.27176 20.7506 8.40655L14.4256 14.7315C14.1495 15.008 13.8034 15.2043 13.4244 15.2994L10.9088 15.9283C10.7926 15.9569 10.6734 15.9712 10.5537 15.9707ZM17.1957 5.86361L11.3781 11.6805C11.2862 11.7727 11.2211 11.8883 11.1898 12.0147L10.5602 14.5303L13.0758 13.9007C13.202 13.869 13.3173 13.8037 13.4093 13.7116L19.2269 7.89408L17.1957 5.86361Z"
                fill="#1D4ED8" />
              <path d="M17.8125 20.8438H7.75C6.79723 20.8426 5.88381 20.4636 5.2101 19.7899C4.53638 19.1162 4.15739 18.2028 4.15625 17.25V7.1875C4.15739 6.23473 4.53638 5.32131 5.2101 4.6476C5.88381 3.97388 6.79723 3.59489 7.75 3.59375H14.6787C14.8694 3.59375 15.0522 3.66948 15.187 3.80427C15.3218 3.93906 15.3975 4.12188 15.3975 4.3125C15.3975 4.50312 15.3218 4.68594 15.187 4.82073C15.0522 4.95552 14.8694 5.03125 14.6787 5.03125H7.75C7.17813 5.03125 6.62968 5.25843 6.2253 5.6628C5.82093 6.06718 5.59375 6.61563 5.59375 7.1875V17.25C5.59375 17.8219 5.82093 18.3703 6.2253 18.7747C6.62968 19.1791 7.17813 19.4062 7.75 19.4062H17.8125C18.3844 19.4062 18.9328 19.1791 19.3372 18.7747C19.7416 18.3703 19.9688 17.8219 19.9688 17.25V10.5009C19.9688 10.3103 20.0445 10.1275 20.1793 9.9927C20.3141 9.85791 20.4969 9.78219 20.6875 9.78219C20.8781 9.78219 21.0609 9.85791 21.1957 9.9927C21.3305 10.1275 21.4062 10.3103 21.4062 10.5009V17.25C21.4051 18.2028 21.0261 19.1162 20.3524 19.7899C19.6787 20.4636 18.7653 20.8426 17.8125 20.8438Z"
                fill="#1D4ED8" />
            </svg>
          </button>
          <button className="inline-flex" aria-label="edit" title="Edit Intended Use Work items"
          onClick={()=>navigate(`/settings/project-setting-intendend/${row.id}`)}>
            <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none" >
              <path d="M15.2521 4.97331C15.6144 4.61106 15.8137 4.12997 15.8137 3.61822C15.8137 3.10647 15.6144 2.62539 15.2521 2.26314L13.7322 0.743224C13.3699 0.380974 12.8889 0.181641 12.3771 0.181641C11.8654 0.181641 11.3843 0.380974 11.023 0.742266L0.833984 10.8996V15.1307H5.06311L15.2521 4.97331ZM12.3771 2.09831L13.898 3.61727L12.3742 5.13526L10.8543 3.61631L12.3771 2.09831ZM2.75065 13.214V11.6951L9.49732 4.96947L11.0172 6.48939L4.27153 13.214H2.75065ZM0.833984 17.0473H16.1673V18.964H0.833984V17.0473Z"
                fill="#1D4ED8" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const showModel = (data) => {
    setIntendedName(data.name);
    setIntendedId(data.id);
    setconintendent(true);
    setErrors("")
    //closeRef.current.focus()
    setErrorMsg("")
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $("#addRename").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#okRename").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideIntendentModel();
          $('.focusAdd').trigger('focus');
          setTimeout(() => {
            $('.inline-flex').removeClass('focusAdd');
            $('.border-right .blue-btn').removeClass('focusAdd');
         }, 500);
        }
      });
    }, 500);
   };
   const handleKeyRenameflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#addRename").trigger("focus");
      }
    }
  };
  
  const hideModel = () => {
    document.body.classList.remove("modal-open");
  };
  const updateName = (e) => {
    setErrorMsg("")
    setErrors('')
    setIntendedName(e);
  };
  
  const createUpdateIntendedUseName = () => {
    if(intendedName.trim() !== ''){
      if (intendedId !== "") {
        putAxiosResponse(APIUrls.UPDATE_CREATE_INTENDED_USE(intendedId), {
          id: intendedId,
          name: intendedName,
        }).then((res) => {
          let error=res?.data?.handledMessage
          if(error){
            setErrors(Constants.DUPLICATE_INTENDED_USE)
            return
          }{
            hideIntendentModel()
          }
            success ? setSuccess(false) : setSuccess(true)
          })
          .catch((err) => {        
            handleError(err);
          });
      } else {
        postAxiosResponse(APIUrls.UPDATE_CREATE_INTENDED_USE(null), {
          id: null,
          name: intendedName,
        }).then((res) => {
          let error=res?.data?.handledMessage
          if(error){
            setErrors(Constants.DUPLICATE_INTENDED_USE)
            return
          }{
            hideIntendentModel()
          }
            success ? setSuccess(false) : setSuccess(true)
          })
          .catch((err) => {
            handleError(err);
          });
      }
    }else{
      setErrors(Constants.REQUIRED_NAME);
      setTimeout(() => {
        $('#addIntendent').trigger('focus');
      }, 10);
    }
  };

  const showIntendentModel = () => {
    setIntendedName("");
    setIntendedId("");
    setErrorMsg("")
    setErrors('')
    setconintendent(false);
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $("#addIntendent").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#OkId").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideIntendentModel();
          $('.focusAdd').trigger('focus');
          setTimeout(() => {
            $('.inline-flex').removeClass('focusAdd');
            $('.border-right .blue-btn').removeClass('focusAdd');
         }, 500);
        }
      });
    }, 500);
  };

  const handleKeyOkflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#addIntendent").trigger("focus");
      }
    }
  };
  const hideIntendentModel = () => {
    document.body.classList.remove("modal-open");
    setIntendedName("");
    backRef.current.focus()
  };
  
  const confirmDelete = (row) => {
    setTimeout(() => {
      $("#deleteNo").trigger("focus");
      $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete Project" } );
    }, 500);
    confirmAlert({
      title: "Confirm Delete Project",
      message: <p>Delete Intended Use: {row.name}</p>,
      buttons: [
        {
          label: "Yes",
          id: "deleteYes",
          onClick: () =>
            deleteAxiosResponse(APIUrls.UPDATE_CREATE_INTENDED_USE(row.id))
              .then((res) => {
                success ? setSuccess(false) : setSuccess(true)
              })
              .catch((err) => {
                handleError(err);
              }),
          onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === true) {
                e.preventDefault();
                $("#deleteNo").trigger("focus");
              }
            }
          },
        },
        {
          label: "No",
          id: "deleteNo",
          onClick: () => {
            $('.focusAdd').trigger('focus');
            $('.inline-flex').removeClass('focusAdd');
          },
          onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              }
            }
            if (e.key === Constants.ESCAPE) {
              $('.focusAdd').trigger('focus');
              $('.inline-flex').removeClass('focusAdd');
            }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
    backRef.current.focus()
  };

  useEffect(() => {
    setPending(true);
    getAxiosResponse(APIUrls.INTENDED_USES_TASKS)
      .then((res) => {
        if (res.data !== "") {
          setPending(false);
          setIntendedUse(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }, [success]);
  
  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  $(document).on("click",".datatable-block .rdt_TableCell button.inline-flex, .border-right .blue-btn",function() {
    $(this).addClass('focusAdd');
   });
  $(document).on("click",".modal-footer .btn",function() {
    $('.focusAdd').trigger('focus');
    $('.inline-flex').removeClass('focusAdd');
    $('.border-right .blue-btn').removeClass('focusAdd');
 });
  $(".rdt_Table").attr("aria-label","Intended Uses and Work Items"); 
  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
   })
   const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Intended use', url:''},
   ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button  ref={backRef} aria-label="back" onClick={() => navigate("/settings")} >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none" >
                      <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8" />
                    </svg>
                  </button>
                  <span>{translate("settings.back_to_settings")}</span>
                </div>
                <h3 className="flex">
                  {translate("settings.intended_use")}
                </h3>
                <span> {translate("settings.category_requires")} </span>
              </div>
              <div className="white-bg">
                <div className="flex flex-center justify-end">
                  <div className="flex two-col border-right">
                    <button className="blue-btn active" onClick={showIntendentModel} >
                      {translate("settings.add")}
                    </button>
                  </div>
                </div>
                
                  <div className="datatable-block">
                    <DataTable
                      keyField="id"
                      columns={columns}
                      data={intendendUse}
                      //defaultSortFieldId={1}
                      responsive
                      striped
                      progressPending={pending}
                      pointerOnHover={true}
                      paginationTotalRows={intendendUse?.length}
                      onSort={handleSort}
                      //defaultSortFieldId="intendendUse.name"
                    />
                  </div>
                
              </div>
            </div>
          </div>
        </section>
      </div>

      {conintendent ? (
        <div className="lightbox-panel edit" aria-labelledby="rename" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="rename">{translate("settings.rename")}</h5>
            </div>
            <div className="lightbox-content padd-22">
              <div className="flex wrap-dropdown mb-0">
                <div className="global-dropdown-block">
                  <label>{translate("settings.name")}</label>
                  <input type="text" className="form-control-sm"
                    title="name" id="addRename" value={intendedName} onChange={(e) => updateName(e.target.value)} />
                    {errors !== '' ? <p className="error">{errors}</p> : ''}
                </div>
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold first-focus" onClick={hideIntendentModel}>
              {translate("settings.cancel")}
              </button>
              <button className="btn btn-bold active" onClick={createUpdateIntendedUseName} id="okRename" onKeyDown={handleKeyRenameflow} >
                {translate("settings.save")}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="lightbox-panel create" aria-labelledby="addIntended" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="addIntended">{translate("settings.add_intended_use")}</h5>
            </div>
            <div className="lightbox-content padd-22">
              <div className="flex wrap-dropdown mb-0">
                <div className="global-dropdown-block">
                  <label>{translate("settings.name")}</label>
                  <input type="text" className="form-control-sm" id="addIntendent" title="name" aria-describedby="errorOnInput"
                    value={intendedName} onChange={(e) => updateName(e.target.value)}
                  />
                  <div>
                    {errors !== '' ? <p className="error" id="errorOnInput">{errors}</p> : ''}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold first-focus" onClick={hideIntendentModel}>
                {translate("settings.cancel")}
              </button>
              <button onKeyDown={handleKeyOkflow} id="OkId" className="btn btn-bold active"
                onClick={createUpdateIntendedUseName} >
                {translate("settings.save")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
